<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer :loading="loading">
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<span style="color: #F56C6C;">excle模板表头：【店铺】【链接ID】【商品名称】【开始日期】【结束日期】</span>
				<vxe-grid ref="competitivegoodsformlist" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "$input",
					"field": "name",
					"title": "任务名称",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				loading:false,
				modal_model:false,
				modal_title: '新建任务',
				modal_width:800,
				modal_height:600,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			importMethod(e){
				this.loading = true
				let file = e.file
				let reader = new FileReader();
				reader.onload = (e) =>{
					let data = e.target.result
					let workbook = this.$XLSX.read(data, {
						type: 'binary',
					})
					let sheetName = workbook.SheetNames[0];
					let worksheet = workbook.Sheets[sheetName]
					let jsonData = this.$XLSX.utils.sheet_to_json(worksheet,{ raw: false })
					let tablecolumns = this.$Lodash.groupBy(this.$refs.competitivegoodsformlist.getColumns(),'title')
					this.$refs.competitivegoodsformlist.reloadData([]).then(() => {
						let insertData = []
						jsonData.forEach((item) => {
							let obj = {id:Math.random()}
							for (let i in item) {
								if(tablecolumns[i]){
									let columns = tablecolumns[i][0]
									if( columns.editRender ){
										if(columns.editRender.name == '$emun'){
											obj[columns.field] = window.systemMethods.getEmunId(columns.editRender.props.name,item[i])
										}else if(columns.editRender.name == '$select'){
											let selectoptions = columns.editRender.props.selectoptions
											let options = selectoptions.find((optionsitem)=>{
												return optionsitem.label == item[i]
											})
											//console.log(options)
											if(options){
												obj[columns.field] = options.value
											}else{
												obj[columns.field] = 10
											}
											//console.log(selectoptions)
										}else if(columns.editRender.name == '$datePicker'){
											//console.log(item[i])
											if(this.importisNumeric(item[i]) &&  item[i] < 1000000000){
												item[i] = this.GMTdate2date(item[i])
											}
											
											//console.log(this.GMTdate2date(item[i]))
											obj[columns.field] = this.$Moment(item[i]).valueOf()
										}else if(columns.editRender.name.startsWith('$') && columns.editRender.props.moduleName){												
											if(!columns.editRender.name.startsWith('$input')){
												//console.log(columns.editRender.props.moduleName)
												obj[columns.field] = window.systemMethods['get'+ columns.editRender.props.moduleName](item[i],'label')
											}
										}else{
											obj[columns.field] = item[i]
										}									
									}else{
										obj[columns.field] = item[i]
									}										
								}
							}																																		
							for(let i in tablecolumns){
								if(tablecolumns[i][0].field){
									if(obj[tablecolumns[i][0].field] === null || obj[tablecolumns[i][0].field] === undefined){
										obj[tablecolumns[i][0].field] = null
									}
								}
							}
							//console.log(obj)
							insertData.push(obj)
						})
						this.$refs.competitivegoodsformlist.reloadData(insertData)
						//console.log(insertData)
						//this.$refs[this.importTableRef].insertAt(insertData)
					})					
					this.loading = false
				}
				reader.readAsBinaryString(file)
			},
			GMTdate2date(serial) {
				
				const startDate = new Date(1900, 0, 1); // 1900-01-01
				const days = serial - 1; // Excel 的 1 = 1900-01-01
				const milliseconds = days * 86400 * 1000; // 1 天 = 86400 秒 * 1000 毫秒
				const date = new Date(startDate.getTime() + milliseconds);
				// 修正 Excel 的 1900 闰年错误（Excel 错误地认为 1900 是闰年）
				//if (serial >= 60) date.setDate(date.getDate());
				//console.log(date)
				return date.toISOString().split('T')[0]
			},
			importisNumeric(value) {
				return (
					(typeof value === 'number' && !isNaN(value)) || // 基本类型数字
					(typeof value === 'string' && !isNaN(parseFloat(value))) // 字符串数字
				)
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 450
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					},{
						name: '导入',
						status: 'success',
						code: 'import'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.importConfig.importMethod = this.importMethod
				gridOptions.columns = [{
						field: 'goodsshop',
						title: '店铺',
						editRender: {
							name: '$input',
							props: {

							},
							events: {
								
							}
						},
					}, {
						field: 'goodscode',
						title: '链接ID',
						editRender: {
							name: '$input',
							props: {
						
							},
							events: {
								
							}
						},
					}, {
						field: 'goodsname',
						title: '商品名称',
						editRender: {
							name: '$input',
							props: {
						
							},
							events: {
								
							}
						},
					}, {
						field: 'beginDate',
						title: '开始日期',
						editRender: {
							name: '$datePicker',
							props: {
								type: 'date'
							},
							events: {

							}
						}
					}, {
						field: 'endDate',
						title: '结束日期',
						editRender: {
							name: '$datePicker',
							props: {
								type: 'date'
							},
							events: {

							}
						},
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.editRules = {
					goodscode: [{
						required: true
					}],
					beginDate: [{
						required: true
					}],
					endDate: [{
						required: true
					}]
				}
			},
			list() {
				return new Promise((resolve) => {
					if(this.data && this.data.id){
						this.$api.competitivegoodstask.listdetail({
							taskid:this.data.id,
						}).then((res)=>{
							resolve(res)
						})
					}else{
						resolve([])
					}
				})

			},
			modal_init(){
				this.loading = false
				if(this.data && this.data.id){
					this.sourceData = this.data
					this.modal_title = '更新任务'
				}else{
					this.modal_title = '新建任务'
				}
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()		
				})
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid(){
				return this.$refs.competitivegoodsformlist
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				this.fApi.submit((formData) => {
					// let submitData = JSON.parse(JSON.stringify(formData))
					// this.submitDataFormater(submitData)
					// this.$api.logistictrace.updatefromlist(this.row.traceID,submitData).then(()=>{
					// 	this.$emit('success')
					// 	this.modal_cancel()
					// })
					// console.log(submitData)
					
					this.getgrid().validate(true, (res) => {
						if (!res) {
							this.loading = true
							let submitData = JSON.parse(JSON.stringify(formData))
							this.submitDataFormater(submitData)
							let detail = this.getgrid().getTableData().visibleData
							let data = {}
							data.main = submitData
							data.goods_detail = detail
							
							if(!this.data.id){
								this.$api.competitivegoodstask.save({
									name:data.main.name,
									goods_detail:data.goods_detail
								}).then(()=>{
									this.$emit('success')
									this.modal_cancel()
								})
							}else{
								this.$api.competitivegoodstask.update(this.data.id,{
									name:data.main.name,
									goods_detail:data.goods_detail
								}).then(()=>{
									this.loading = false
									this.$emit('success')
									this.modal_cancel()
								},()=>{
									this.loading = false
								})
							}
							
							//this.createJson(data)
							//console.log(data,123123)
							console.log(data)
						} else {
							this.loading = false
							for (let i in res) {
								console.log(res[i][0].rule)
								let content = res[i][0].rule.$options.content
								let message = res[i][0].rule.$options.message
								if(content){
									this.$message.error(content)
								}else if(message){
									this.$message.error(message)
								}else{
									this.$message.error('缺少必填项：' + res[i][0].column.title)
								}
								
							}
						}
					})
					
					
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>